import React from 'react';
import ReactDOM from 'react-dom';
import drupalSettings from 'drupalSettings';
import Drupal from 'Drupal';
import buildUrl from 'build-url';
import Select from 'react-select';
import ReactPaginate from 'react-paginate';
import withSessionStorage from './session-storage/withSessionStorage';
import {DebounceInput} from 'react-debounce-input';

let API_URL = '/api/pillars';
if (drupalSettings.path.currentLanguage === 'fr') {
    API_URL = '/fr/api/pillars';
}

class PillarItem extends React.Component {
    constructor(props) {
        super(props);
        this.goToPillar = this.goToPillar.bind(this);
    }

    goToPillar() {
        return window.location = this.props.pillar.nothing;
    }

    render() {
        let imgUrl = `${this.props.pillar.field_member_pg_logo}`;

        if (this.props.pillar.field_logo_i === 'Use the header image') {
            if (this.props.pillar.field_member_header_image) {
                imgUrl = `${this.props.pillar.field_member_header_image}`
            }
        }

        return (
            <div onClick={this.goToPillar}
                 className="four-column-grid-item w-inline-block">
                <div className="four-column-grid-item-wrapper">
                <img src={imgUrl}
                         className="four-column-grid-item-image imgiximage"
                         alt={this.props.pillar.title}/>
                    <h4 className="four-column-grid-heading"
                        dangerouslySetInnerHTML={{__html: this.props.pillar.title}}></h4>
                </div>
            </div>
        )
    }
}

class Pillar extends React.Component {
    constructor(props) {
        super(props);
        this.handleTitleChange = this.handleTitleChange.bind(this);
        this.handleLoadMore = this.handleLoadMore.bind(this);
        this.handleAreaSelect = this.handleAreaSelect.bind(this);
        this.handleCategorySelect = this.handleCategorySelect.bind(this);
        this.clearAll = this.clearAll.bind(this);
        this.state = {
            pillars: [],
            search: '',
            page: 0,
            pageCount: 0,
            selectedCategories: [],
            selectedArea: null,
            categories: drupalSettings.pillar.categories,
            areas: drupalSettings.pillar.areas,
            showLoadMore: false,
            loading: true,
            hasFilters: false
        };

        this.pillarRef = null;
    }

    buildUrl() {
        var query = {
            'page': this.state.page,
            'field_member_page_type_value': drupalSettings.pillar.category_type,
            '_format': 'json'
        };

        if (this.state.search !== '') {
            query.title = this.state.search
        }

        if (this.state.selectedCategories.length !== 0) {
            if (drupalSettings.pillar.category_type === 'Food & Drink') {
                var selectedCategories = [];
                this.state.selectedCategories.forEach((category) => {
                    selectedCategories.push(category.value)
                })
                query['field_member_cuisine_types_target_id[]'] = selectedCategories
            }

            if (drupalSettings.pillar.category_type === 'Urban Culture') {
                var selectedCategories = [];
                this.state.selectedCategories.forEach((category) => {
                    selectedCategories.push(category.value)
                })
                query['field_place_urban_type_target_id[]'] = selectedCategories
            }
        }

        if (this.state.selectedArea !== null) {
            query['field_member_areas_target_id'] = this.state.selectedArea.value
        }

        if (this.state.search !== '' || this.state.selectedCategories.length !== 0 || this.state.selectedArea) {
            this.setState({hasFilters: true})
        }
        else {
            this.setState({hasFilters: false})
        }

        this.setState({loading: true})

        var url = buildUrl(API_URL, {
            disableCSV: true,
            queryParams: query
        });

        return url
    }

    componentDidMount() {
        this.setState(this.props.getStateFromSessionStorage(this), () => {
            if (window.location.search.substr(1) !== '') {
                var queryDict = {}
                location.search.substr(1).split("&").forEach(function (item) {
                    queryDict[item.split("=")[0]] = item.split("=")[1]
                })

                if (queryDict.selectedCategory || queryDict.selectedArea) {
                    var selectedCategories = []
                    var selectedAreas = []
                    this.state.categories.forEach((category) => {
                        if (category.value === queryDict.selectedCategory) {
                            selectedCategories.push(category);
                        }
                    })

                    this.state.areas.forEach((area) => {
                        if (area.value === queryDict.selectedArea) {
                            selectedAreas.push(area);
                        }
                    })

                    this.setState({
                        selectedCategories: selectedCategories,
                        selectedArea: (selectedAreas.length) ? selectedAreas[0] : null
                    }, () => {
                        this.updatePillars(true, true);
                    })

                    return;
                }
            }

            this.updatePillars(true)
        });
    }

    componentWillUnmount() {
        clearTimeout(this.timeout);
    }

    updatePillars(clear, scroll) {
        var url = this.buildUrl()

        if (clear) {
            this.setState({pillars: []})
        }

        fetch(url)
            .then(response => response.json())
            .then(data => {
                this.setState({
                    pillars: this.state.pillars.concat(data.results),
                    loading: false,
                    pageCount: data.pager.pages
                })
            })

        if (scroll === true) {
            window.scrollTo(0, this.pillarRef.offsetTop)
        }
    }

    handleTitleChange(event) {
        this.setState({
            search: event.target.value,
            page: 0
        }, () => {
            this.updatePillars(true)
        });
    }

    handleLoadMore(page) {
        this.setState(
            {page: (page.selected) ? parseInt(page.selected) : null},
            () => {
                this.updatePillars(true, true)
            }
        );
    }

    handleCategorySelect(categories) {
        this.setState(
            {
                selectedCategories: categories,
                page: 0
            },
            () => {
                this.updatePillars(true)
            }
        )
    }

    handleAreaSelect(area) {
        this.setState(
            {
                selectedArea: area,
                page: 0
            },
            () => {
                this.updatePillars(true)
            }
        )
    }

    matchColor(categoryType) {
        if (categoryType === 'Food & Drink') {
            return "#f28e13";
        }
        if (categoryType === 'History') {
            return '#d90e0d';
        }
        if (categoryType === 'Outdoor Adventures') {
            return '#367cc0';
        }
        if (categoryType === 'Urban Culture') {
            return '#1f2758';
        }

        return '#fec100';
    }

    clearAll() {
        this.setState(
            {
                selectedArea: null,
                search: '',
                selectedCategories: [],
                loading: true,
                page: 0
            },
            () => {
                this.updatePillars(true)
            }
        );
    }

    render() {
        return (
            <div className="section-member-cards"
                 ref={(ref) => this.pillarRef = ref}>
                <div className="blue-heading-block-tall">
                    <div className="blue-heading-block-tall-container">
                        <h2 className="blue-heading-header">{Drupal.t(drupalSettings.pillar.title)}</h2>
                        <div className="blue-heading-block-tall-bottom-row">
                            <form className="member-search w-form">
                                <DebounceInput
                                    minLength={2}
                                    debounceTimeout={500}
                                    className="section-search-input w-input"
                                    maxLength="256"
                                    name="query"
                                    placeholder={Drupal.t('Search')}
                                    id="section-search"
                                    type="search"
                                    value={this.state.search}
                                    onChange={this.handleTitleChange}/>
                            </form>
                            <div className="form-block w-form">
                                {(drupalSettings.pillar.category_type === 'Food & Drink') ?
                                    <div className="select-wrapper">
                                        <Select
                                            name="category-select"
                                            placeholder={Drupal.t('All Types')}
                                            value={this.state.selectedCategories}
                                            onChange={this.handleCategorySelect}
                                            isMulti={true}
                                            options={drupalSettings.pillar.categories}
                                            theme={theme => ({
                                                ...theme,
                                                borderRadius: 0,
                                                border: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: this.matchColor(drupalSettings.pillar.category_type),
                                                    primary: "#fec100",
                                                    neutral20: this.matchColor(drupalSettings.pillar.category_type)
                                                },
                                                spacing: {
                                                    ...theme.spacing,
                                                    menuGutter: 0
                                                }
                                            })}
                                            className='react-select-container'
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                    : null}
                                {(drupalSettings.pillar.category_type === 'Urban Culture') ?
                                    <div className="select-wrapper">
                                        <Select
                                            name="category-select"
                                            placeholder={Drupal.t('Urban Culture Type')}
                                            value={this.state.selectedCategories}
                                            onChange={this.handleCategorySelect}
                                            isMulti={true}
                                            options={drupalSettings.pillar.categories}
                                            theme={theme => ({
                                                ...theme,
                                                borderRadius: 0,
                                                border: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    primary25: this.matchColor(drupalSettings.pillar.category_type),
                                                    primary: "#fec100",
                                                    neutral20: this.matchColor(drupalSettings.pillar.category_type)
                                                },
                                                spacing: {
                                                    ...theme.spacing,
                                                    menuGutter: 0
                                                }
                                            })}
                                            className='react-select-container'
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                    : null}
                                <div
                                    className={(drupalSettings.pillar.category_type === 'Food & Drink' || drupalSettings.pillar.category_type === 'Urban Culture') ? 'select-wrapper' : 'select-wrapper select-wrapper-single-item'}>
                                    <Select
                                        name="area-select"
                                        value={this.state.selectedArea}
                                        onChange={this.handleAreaSelect}
                                        placeholder={Drupal.t('Areas')}
                                        options={drupalSettings.pillar.areas}
                                        theme={theme => ({
                                            ...theme,
                                            borderRadius: 0,
                                            border: 0,
                                            colors: {
                                                ...theme.colors,
                                                primary25: this.matchColor(drupalSettings.pillar.category_type),
                                                primary: "#fec100",
                                                neutral20: this.matchColor(drupalSettings.pillar.category_type)
                                            },
                                            spacing: {
                                                ...theme.spacing,
                                                menuGutter: 0
                                            }
                                        })}
                                        className='react-select-container'
                                        classNamePrefix="react-select"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="four-column-grid w-clearfix">
                    {(this.state.loading !== true && this.state.hasFilters) ?
                        <div className="clear-all-container"><a
                            className="clear-all"
                            onClick={this.clearAll}>{Drupal.t('Clear All')}</a>
                        </div> : null}

                    <div className="four-column-grid-container">
                        {this.state.pillars.map(function (pillar, index) {
                            return <PillarItem pillar={pillar}
                                               key={index}></PillarItem>;
                        })}

                        {(this.state.pillars.length === 0 && this.state.loading === false) ?
                            <div
                                className="no-results-found">{Drupal.t('No results found.')}</div> : null}

                        {(this.state.loading === true) ?
                            <div className="loading">
                                <svg width="70px" height="70px"
                                     viewBox="140 -1 68 70" version="1.1"
                                     id="SJN_PHYhsG">
                                    <g id="rkHuwrY2jG" fillRule="evenodd">
                                        <g id="HJUuvrK3sf">
                                            <g id="rJPdPBFnoM_HkudSK2oz">
                                                <path
                                                    d="M0.1640625,28.1757812 C5.79354297,33.2055813 11.3312056,35.7432439 16.7770503,35.788769 C22.222895,35.8342942 27.6687397,33.3884495 33.1145845,28.4512349 C39.1033043,33.9747803 44.909886,36.781362 50.5343296,36.87098 C56.1587732,36.960598 61.7832168,34.3361544 67.4076604,28.9976492 C73.8347605,35.0245907 79.9290891,38.1189193 85.6906461,38.280635 C91.4522032,38.4423507 97.2137602,35.6807936 102.975317,29.9959639 C109.444473,35.7527492 115.437072,38.7453478 120.953113,38.9737596 C126.469154,39.2021713 131.985196,36.6861299 137.501237,31.4256352 C143.143013,36.0387188 148.515214,38.4109199 153.617841,38.5422385 C158.720467,38.6735571 163.823093,36.5709309 168.925719,32.2343598 C174.985169,37.9062501 180.86526,40.7863407 186.565991,40.8746315 C192.266722,40.9629222 197.967453,38.2621911 203.668184,32.7724381 C209.227767,37.9814772 214.823277,40.5769865 220.454712,40.5589659 C226.086148,40.5409454 231.717583,37.9095099 237.349018,32.6646595 C243.480762,39.422327 249.809573,42.7511384 256.335453,42.6510937 C262.861332,42.5510491 269.387212,39.0251696 275.913091,32.0734552 C281.933116,37.6303339 287.759216,40.4564339 293.391391,40.5517552 C299.023567,40.6470765 304.655742,38.0149012 310.287917,32.6552291 C316.005362,38.9498739 322.064831,42.0093431 328.466325,41.8336367 C334.867819,41.6579303 341.269313,38.2564362 347.670807,31.6291543 C353.197442,36.7591832 358.754763,39.3165046 364.342772,39.3011187 C369.930781,39.2857328 375.518789,36.697724 381.106798,31.5370922"
                                                    id="rJPdPBFnoM"/>
                                            </g>
                                            <circle id="HkuuPrFnoG" cx="173.5"
                                                    cy="33.5" r="33.5"/>
                                        </g>
                                    </g>
                                </svg>
                            </div> : null}
                    </div>

                    {this.state.pageCount > 1 ?
                        <ReactPaginate
                            previousLabel={'previous'}
                            nextLabel={'next'}
                            breakLabel={'...'}
                            breakClassName={'break-me'}
                            pageCount={this.state.pageCount}
                            marginPagesDisplayed={0}
                            pageRangeDisplayed={3}
                            onPageChange={this.handleLoadMore}
                            containerClassName={'pagination'}
                            subContainerClassName={'pages pagination'}
                            activeClassName={'active'}
                            initialPage={parseInt(this.state.page)}
                            forcePage={this.state.page}
                            disableInitialCallback={true}
                        />
                        : null}
                </div>
            </div>
        )
    }
}

Pillar.sessionStorageKeys = ['selectedCategories', 'selectedArea', 'page', 'search'];
Pillar.sessionStorageNamespace = drupalSettings.pillar.category_type.toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');

Pillar = withSessionStorage(Pillar);

export default Pillar;
